import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectCurrentUser, selectIsCustomer } from '@components/Auth';
import { mergeInitialValues } from '@utils/formik';
import { FormValuesForCreate, useFormParams, useFormValues } from '@components/HealthQuoteBuyRoute/HealthQuoteBuyForm';

import { selectPersonalAccidentQuoteBuyRoute } from '../selector';

export const useInitialValues = () => {
  const currentUser = useSelector(selectCurrentUser);
  const isCustomer = useSelector(selectIsCustomer);
  const { personalAccidentQuote } = useSelector(selectPersonalAccidentQuoteBuyRoute);
  const params = useFormParams();
  const values = useFormValues();
  const valuesForCreate: FormValuesForCreate = { ...values, planId: '', activationDate: '' };
  return useMemo(() => {
    if (!currentUser) return;
    if (!personalAccidentQuote) return;
    const { members, personalAccidentPlanId } = personalAccidentQuote;
    return mergeInitialValues(
      valuesForCreate,
      isCustomer ? { me: currentUser } : undefined,
      { ...personalAccidentQuote, ...members, planId: personalAccidentPlanId },
      params
    );
  }, [currentUser, personalAccidentQuote]);
};
